import * as React from 'react'
import { Link } from 'react-router-dom'
import { LucideIcon } from 'utils/lucideIcon'
import { useTranslation } from 'translations'

interface CapacityTopBarProps {
    backTo: string
    reportTo?: string
    children?: React.ReactNode
}

export function CapacityTopBar({ backTo, reportTo, children }: CapacityTopBarProps) {
    const { t } = useTranslation()
    return (
        <div className="capacity-topbar">
            <div className="capacity-topbar-links">
                <Link to={backTo} className="capacity-back-link">
                    <LucideIcon iconName="ArrowLeft" size={16} />
                    {t('capacity.section.backToList')}
                </Link>
                {reportTo && (
                    <Link to={reportTo} className="capacity-report-link">
                        {t('capacity.section.reportLink')}
                    </Link>
                )}
            </div>
            {children}
        </div>
    )
}
